import { Card, Grid, Typography } from '@mui/material';
import { BakeasyButtonIconBack } from '../buttons/BakeasyButton';

export interface BakeasyAppBarProps {
  title?: any;
  clickable?: boolean;
  icon?: any;
  menus?: any;
  onBackClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

export function BakeasyAppBar(props: BakeasyAppBarProps) {
  return (
    <Card>
      <Grid
        container
        spacing={1}
        sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: 1 }}
      >
        <Grid item xs={12} sm={12} md={5} lg={5} xl={5}>
          <Grid container sx={{ alignItems: 'center', justifyContent: 'start' }}>
            <div className="tableOptions">
              <BakeasyButtonIconBack onClick={props?.onBackClick} />
              <Grid sx={{ alignItems: 'center', display: 'flex' }}>
                <Typography>{props?.title}</Typography>
              </Grid>
            </div>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={7} lg={7} xl={7}>
          {props?.menus && (
            <Grid container sx={{ alignItems: 'center', justifyContent: 'end' }}>
              {props?.menus}
            </Grid>
          )}
        </Grid>
      </Grid>
    </Card>
  );
}
